module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UN7rgOUehpOqc.1edc4ebb.woff2";